import React, { useContext } from 'react';

import {
  useCreateExceptionForm,
  normalizeReceiveExceptionRequest,
  parseCreateExceptionRequest,
  ExceptionFormSchema,
} from '@amzn/awsscmui-argo-inventory-exception/common/main';

import { omit } from 'lodash';
import { v4 as uuidv4 } from 'uuid';

import { useGetUserInformation } from '../../appSelectorContext';
import { BOOST_EXCEPTION_CLIENT_SAME } from '../../boost/utils';
import { httpFetch, EXCEPTION_URL_MAPPING } from '../../hooks/useHttp';
import { AppContext } from '../../store/appContext';
import { ExceptionModal } from './ExceptionsModal';
import { DEFAULT_ERROR_MESSAGE } from './constants';
import { NotifyProps } from './types';

interface BoostExceptionProps {
  setNotify: (notify: any) => void;
  formState: any;
  appConfig: any;
  notify: NotifyProps;
  onDismiss: () => void;
}

export function BoostException({ setNotify, notify, formState, appConfig, onDismiss }: BoostExceptionProps) {
  const userContext = useGetUserInformation();
  const appContext = useContext(AppContext);

  const handleOnBoostFormSubmit = async (values: any) => {
    try {
      // omitting serial,tag and entire order
      const valuesToSubmit = omit(values, ['serial', 'tag', 'entireOrder']);
      const request = normalizeReceiveExceptionRequest(
        parseCreateExceptionRequest(valuesToSubmit, ExceptionFormSchema),
      );
      delete request.status;
      const response = await httpFetch(EXCEPTION_URL_MAPPING.create, {
        headers: {
          'content-type': 'application/json; charset=utf-8',
        },
        body: {
          ...request,
          createdBy: {
            contact: userContext?.user,
          },
          clientRequestToken: uuidv4(),
          clientName: BOOST_EXCEPTION_CLIENT_SAME,
          // client work request id for the boost workflow
          clientWorkRequestId: appContext.context.workRequestId,
        },
        method: 'POST',
      });
      // once the exception form is submitted boost exception workrequest will be created
      const boostExceptionWorkRequestId = response?.boostExceptionWorkRequestId;
      setNotify({
        success: {
          message: `Successfully created exception - ${response?.exceptionId}`,
          context: {
            boostExceptionWorkRequestId,
            title: 'Boost exception workrequest Id',
          },
        },
      });
    } catch (e) {
      console.error('handleOnBoostFormSubmit: error', e);
      setNotify({
        error: {
          message: DEFAULT_ERROR_MESSAGE,
          context: {
            // error,
          },
        },
      });
    }
  };

  const form = useCreateExceptionForm(handleOnBoostFormSubmit);

  return (
    <ExceptionModal
      form={form}
      notify={notify}
      formState={{ ...formState }}
      appConfig={appConfig}
      show
      onDismiss={onDismiss}
    />
  );
}
